import * as React from "react"
import { Checkbox as CheckboxPrimitive } from "radix-ui"
import { CheckIcon, MinusIcon } from "lucide-react"

import { cn } from "../../../lib/utils"

function Checkbox({
  className,
  checked,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        // DESIGN.md `checkbox`: 16×16, 1px gray-300 border, 4px radius, brand-blue when checked
        "peer size-4 shrink-0 rounded-[4px] border border-input-border bg-card transition-colors outline-none cursor-pointer",
        "hover:border-foreground/40",
        "focus-visible:ring-[2px] focus-visible:ring-ring/40",
        "data-[state=checked]:bg-primary data-[state=checked]:border-primary data-[state=checked]:text-primary-foreground",
        "disabled:cursor-not-allowed disabled:opacity-40",
        "aria-invalid:border-error aria-invalid:ring-error/20",
        className,
      )}
      checked={checked}
      {...props}
    >
      <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
        {checked === "indeterminate" ? (
          <MinusIcon className="size-3 text-current" strokeWidth={3} />
        ) : (
          <CheckIcon className="size-3 text-current" strokeWidth={3} />
        )}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
